import React from "react";

export default function CreatingCard({selectedIcon, formName, selectedColor}) {
	return (
		<div className="card hover processes b-shadow b-radius w-100 pt-3 pb-5 border-0 position-relative">
			<div className="card-body justify-content-center text-center">
				<div className="icon-holder b-shadow mt-3 mb-4">
					<i className={`pi ${selectedIcon || ""} fs-3 p-3 text-${selectedColor || ""}`}></i>
				</div>
				<span className="mb-0 text-uppercase">{formName || "please enter card title"}</span>
			</div>
		</div>
	);
}
